import { getRoomTag } from '../../../../../../modules/room-tag-storage';

export async function sortRoomPageSections() {
  const roomTag = await getRoomTag();
  if (!roomTag) {
    return;
  }

  const cateringSection = document.querySelector('#roomCateringSection');
  const cateringSectionSeparator = document.querySelector('#room_features-separator');
  const hostRules = document.querySelector('#host_rules');
  const rulesOfTheSpace = document.querySelector('#rules_of_the_space');
  const rulesOfTheSpaceSeparator = document.querySelector('#rules_of_the_space-separator');
  const roomFeaturesSection = document.querySelector('#room_features');
  const musicAndSoundEqupiment = document.querySelector('#music_and_sound_equipment');
  const musicAndSoundEqupimentSeparator = document.querySelector('#music_and_sound_equipment-separator');
  const allowedEvents = document.querySelector('#allowedEvents');
  const agePolicy = document.querySelector('#agePolicy');
  const canBringYourOwnDj = document.querySelector('#can_bring_your_own_dj');
  const canPlayYourOwnMusic = document.querySelector('#can_play_your_own_music');
  if (!cateringSection || !roomFeaturesSection) {
    return;
  }
  // TODO move to shared
  const categories = [
    {
      category: 'Meeting',
      items: ['wifi', 'conference-calls', 'projector', 'ac', 'flipchart', 'parking'],
      tags: ['meeting', 'meeting-room', 'boardroom', 'classroom', 'market-research', 'training-room', 'workshop', 'team-building', 'off-site', 'it-training'],
    },
    {
      category: 'Business',
      items: ['wifi', 'pa-system', 'projector', 'ac', 'tv', 'parking'],
      tags: ['conference', 'product-launch', 'activity-day', 'seminar', 'awards-ceremony', 'pr-event', 'agm', 'breakout', 'convention', 'presentation', 'press-conference', 'symposium', 'promotional-event'],
    },
    {
      category: 'Wedding',
      items: ['alcohol-licence', 'alcohol-licence-extension', 'pa-system', 'own-music-allowed',
        'wedding-licence', 'parking'],
      tags: ['wedding', 'asian-weddings', 'outdoor-wedding', 'unusual-wedding', 'wedding-ceremonies', 'wedding-reception', 'civil-ceremony-venues', 'civil-partnership', 'marquee-wedding', 'unique-wedding', 'garden-wedding', 'dry-hire-wedding'],
    },
    {
      category: 'Party',
      items: ['alcohol-licence', 'alcohol-licence-extension', 'pa-system', 'own-music-allowed',
        'promoted-ticketed-events', 'minimum-spend-pricing'],
      tags: ['party', 'birthday-party', '18th-birthday-party', '40th-birthday-party', '50th-birthday-party', 'private-party', 'hen-party', 'stag-party', 'leaving-party', 'graduation-party', 'new-years-eve-party'],
    },
    {
      category: 'Production',
      items: ['wifi', 'natural-light', 'pa-system', 'storage-space',
        'cargo-lift', 'ac'],
      tags: ['creative-space', 'art-studio', 'photo-studio', 'dance-studio', 'film-studio', 'filming-location', 'drama-studio', 'rehearsal-rooms', 'rehearsal-studio', 'recording-studio', 'tv-studio',
        'photo-shoot', 'blank-canvas',
      ],
    },
  ];
  const tagCategory = categories.find(category => category.tags.find(tag => tag === roomTag))?.category;
  if (!tagCategory) {
    return;
  }
  if (tagCategory === 'Meeting' || tagCategory === 'Production') {
    cateringSection.parentNode.insertBefore(roomFeaturesSection, cateringSection);
    cateringSection.parentNode.insertBefore(cateringSectionSeparator, cateringSection);
  }
  if (tagCategory === 'Meeting') {
    // hide sections
    musicAndSoundEqupiment.style.display = 'none';
    musicAndSoundEqupimentSeparator.style.display = 'none';
    allowedEvents.style.display = 'none';
    // is allowedEvents are the only child of the section hide the section
    if (allowedEvents.parentElement.children.length === 1) {
      rulesOfTheSpace.style.display = 'none';
      rulesOfTheSpaceSeparator.style.display = 'none';
    }
    if (hostRules) {
      hostRules.style.marginTop = '0';
    }
    if (agePolicy) {
      agePolicy.style.display = 'none';
    }
  }
  if (tagCategory === 'Production') {
    // hide sections
    cateringSection.style.display = 'none';
    cateringSectionSeparator.style.display = 'none';
    if (hostRules) {
      hostRules.style.marginTop = '16px';
    }
    if (agePolicy) {
      agePolicy.style.display = 'none';
    }
    canBringYourOwnDj.style.display = 'none';
    canPlayYourOwnMusic.style.display = 'none';
  }
}
